export default "__VITE_ASSET__2136562d__"